/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

/**
 * Response body for requesting an authorization for a transaction
 */

// required attributes
const RequestAuthorizationResponseR = t.interface({
  authorizationUrl: t.string,

  authorizationRequestId: t.string
});

// optional attributes
const RequestAuthorizationResponseO = t.partial({});

export const RequestAuthorizationResponse = t.intersection(
  [RequestAuthorizationResponseR, RequestAuthorizationResponseO],
  "RequestAuthorizationResponse"
);

export type RequestAuthorizationResponse = t.TypeOf<
  typeof RequestAuthorizationResponse
>;
